export default __webpack_public_path__ + "static/media/36I-102696_-15657_0.fe671e19.jpg";